module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-11-7b5919417ee2bcdfe52f2484214480c8.webp";